import authKeys from './auth.keys';
import botsKeys from './bots.keys';
import coachKeys from './coach.keys';
import commentKeys from './comment.keys';
import commonKeys from './common.keys';
import courseKeys from './course.keys';
import educationalKeys from './educational.keys';
import exploreKeys from './explore.keys';
import gateWayKeys from './gateway.keys';
import notificationsKeys from './notifications.keys';
import pageKeys from './page.keys';
import paymentKeys from './payment.keys';
import planKeys from './plan.keys';
import programKeys from './programs.keys';
import supportKeys from './support.keys';
import userKeys from './user.keys';

const ApiKeys = {
    ...authKeys,
    ...courseKeys,
    ...educationalKeys,
    ...commonKeys,
    ...coachKeys,
    ...commentKeys,
    ...paymentKeys,
    ...gateWayKeys,
    ...supportKeys,
    ...pageKeys,
    ...planKeys,
    ...exploreKeys,
    ...programKeys,
    ...userKeys,
    ...botsKeys,
    ...notificationsKeys
};

export default ApiKeys;
